import { request } from "@/util/http";

export const getUserAndDevice = (currentPage, pageSize, params) => {
  return request({
    url: "/manage/getUserAndDevice",
    method: "get",
    params: {
      ...params,
      currentPage,
      pageSize,
    },
  });
};

export const getDeviceDetails = (currentPage, pageSize, params) => {
  return request({
    url: "/manage/getDeviceDetails",
    method: "get",
    params: {
      ...params,
      currentPage,
      pageSize,
    },
  });
};

export const getWorkIssue = (currentPage, pageSize, params) => {
  return request({
    url: "/manage/getWorkIssue",
    method: "get",
    params: {
      ...params,
      currentPage,
      pageSize,
    },
  });
};

export const saveOrUpdateWorkIssue = (params) => {
  return request({
    url: "/manage/saveOrUpdateWorkIssue",
    method: "get",
    params: {
      ...params,
    },
  });
};

export const deleteWorkIssue = (params) => {
  return request({
    url: "/manage/deleteWorkIssue",
    method: "get",
    params: {
      ...params,
    },
  });
};

export const getSales = (currentPage, pageSize, params) => {
  return request({
    url: "/manage/getSales",
    method: "get",
    params: {
      ...params,
      currentPage,
      pageSize,
    },
  });
};

export const saveOrUpdateSales = (params) => {
  return request({
    url: "/manage/saveOrUpdateSales",
    method: "get",
    params: {
      ...params,
    },
  });
};

export const deleteSales = (params) => {
  return request({
    url: "/manage/deleteSales",
    method: "get",
    params: {
      ...params,
    },
  });
};

export const getFeedBacks = (currentPage, pageSize, params) => {
  return request({
    url: "/manage/getFeedBacks",
    method: "get",
    params: {
      ...params,
      currentPage,
      pageSize,
    },
  });
};

export const saveOrUpdateFeedBack = (params) => {
  return request({
    url: "/manage/saveOrUpdateFeedBack",
    method: "get",
    params: {
      ...params,
    },
  });
};

export const deleteFeedBack = (params) => {
  return request({
    url: "/manage/deleteFeedBack",
    method: "get",
    params: {
      ...params,
    },
  });
};

export const doctorGetVip = (currentPage, pageSize, params) => {
  return request({
    url: "/manage/doctorGetVip",
    method: "get",
    params: {
      ...params,
      currentPage,
      pageSize,
    },
  });
};

export const onlineManage = (currentPage, pageSize, params) => {
  return request({
    url: "/manage/onlineManage",
    method: "get",
    params: {
      ...params,
      currentPage,
      pageSize,
    },
  });
};

// 获取最新数据
export const getRecentData = (wxUserId) => {
  return request({
    url: "/manage/getRecentData",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

// 获取首次绑定
export const getFirstBind = (wxUserId) => {
  return request({
    url: "/manage/getFirstBind",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

// 修改首次绑定
export const updFisBind = (params) => {
  return request({
    url: "/manage/updFisBind",
    method: "get",
    params: {
      ...params,
    },
  });
};

// 获取数字档案
export const getDigitalArchives = (wxUserId) => {
  return request({
    url: "/manage/getDigitalArchives",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

// 获取方案
export const getScheme = (wxUserId) => {
  return request({
    url: "/manage/getScheme",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

// 获取方案
export const getMessagePush = (wxUserId) => {
  return request({
    url: "/manage/getMessagePush",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

// 获取行为治疗
export const getBehavior = (wxUserId, date) => {
  return request({
    url: "/manage/getBehavior",
    method: "get",
    params: {
      wxUserId,
      date,
    },
  });
};

// 获取本月打卡情况
export const getBehaviorThisMonth = (wxUserId, date) => {
  return request({
    url: "/manage/getBehaviorThisMonth",
    method: "get",
    params: {
      wxUserId,
      date,
    },
  });
};

// 获取某一天 就餐详情
export const getFoodMenuToday = (wxUserId, date) => {
  return request({
    url: "/manage/getFoodMenuToday",
    method: "get",
    params: {
      wxUserId,
      date,
    },
  });
};

// 获取某一天 运动详情
export const getMotionToday = (wxUserId, date) => {
  return request({
    url: "/manage/getMotionToday",
    method: "get",
    params: {
      wxUserId,
      date,
    },
  });
};

// 获取亚健康
export const getSubHealth = (wxUserId) => {
  return request({
    url: "/manage/getSubHealth",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

// 获取亚健康
export const getSubHealth2 = (wxUserId) => {
  return request({
    url: "/manage/getSubHealth2",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

// 获取慢性病
export const getChronicDisease = (wxUserId) => {
  return request({
    url: "/manage/getChronicDisease",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

// 获取慢性病
export const getChronicDisease2 = (wxUserId) => {
  return request({
    url: "/manage/getChronicDisease2",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

// 获取体成分数据
export const getBodyData = (wxUserId) => {
  return request({
    url: "/manage/getBodyData",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

// 获取达标报告
export const getComplianceReport = (wxUserId) => {
  return request({
    url: "/manage/getComplianceReport",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

// 获取达标报告 通过具体时间
export const getComplianceReportByThatWeek = (wxUserId, thatWeek) => {
  return request({
    url: "/manage/getComplianceReportByThatWeek",
    method: "get",
    params: {
      wxUserId,
      thatWeek,
    },
  });
};

// 确认查看
export const view = (wxUserId) => {
  return request({
    url: "/manage/view",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

// 获取风险
export const getRisk = (wxUserId) => {
  return request({
    url: "/manage/getRisk",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

// 修改用户标签
export const updateFlag = (wxUserId, flag) => {
  return request({
    url: "/manage/updateFlag",
    method: "get",
    params: {
      wxUserId,
      flag,
    },
  });
};

// 修改家庭医生
export const updatedoc = (wxUserId, doc) => {
  return request({
    url: "/manage/updatedoc",
    method: "get",
    params: {
      wxUserId,
      doc,
    },
  });
};

// 修改家医助理
export const updatedoc2 = (wxUserId, doc) => {
  return request({
    url: "/manage/updatedoc2",
    method: "get",
    params: {
      wxUserId,
      doc,
    },
  });
};

// 获取风险数据
export const getTumourRisk = (wxUserId) => {
  return request({
    url: "/manage/getTumourRisk",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

// 线上访随
export const getOnlineFollow = (currentPage, pageSize, params) => {
  return request({
    url: "/manage/getOnlineFollow",
    method: "get",
    params: {
      ...params,
      currentPage,
      pageSize,
    },
  });
};

export const saveOrUpdateOnlineFollow = (params) => {
  return request({
    url: "/manage/saveOrUpdateOnlineFollow",
    method: "get",
    params: {
      ...params,
    },
  });
};

export const deleteOnlineFollow = (params) => {
  return request({
    url: "/manage/deleteOnlineFollow",
    method: "get",
    params: {
      ...params,
    },
  });
};

export const getColorPunch = (wxUserId, year, month, day) => {
  return request({
    url: "/manage/getColorPunch",
    method: "get",
    params: {
      wxUserId,
      year,
      month,
      day,
    },
  });
};

export const getQa = (wxUserId) => {
  return request({
    url: "/manage/getQa",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const getQaItem = (wxUserId, qaId) => {
  return request({
    url: "/manage/getQaItem",
    method: "get",
    params: {
      wxUserId,
      qaId,
    },
  });
};

export const getAllQaItem = (wxUserId, qaId) => {
  return request({
    url: "/manage/getAllQaItem",
    method: "get",
    params: {
      wxUserId,
      qaId,
    },
  });
};

export const getReportNew = (wxUserId, reportType) => {
  return request({
    url: "/manage/getReportNew",
    method: "get",
    params: {
      wxUserId,
      reportType,
    },
  });
};

export const addOrUpdateReportNew = (row) => {
  return request({
    url: "/manage/addOrUpdateReportNew",
    method: "post",
    data: row,
  });
};

export const delReportNew = (id) => {
  return request({
    url: "/manage/delReportNew",
    method: "get",
    params: {
      id,
    },
  });
};

export const getMotion = (wxUserId) => {
  return request({
    url: "/manage/getMotion",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const getLocalAlarm = (currentPage, pageSize, params) => {
  return request({
    url: "/manage/getLocalAlarm",
    method: "get",
    params: {
      ...params,
      currentPage,
      pageSize,
    },
  });
};

export const updateRecord = (g4WatchLocalAlarm) => {
  return request({
    url: "/manage/updateRecord",
    method: "post",
    data: g4WatchLocalAlarm,
  });
};

// 确认查看 sos
export const setReponseTime = (id) => {
  return request({
    url: "/manage/setReponseTime",
    method: "get",
    params: {
      id,
    },
  });
};

export const getDocFollow = (currentPage, pageSize, params) => {
  return request({
    url: "/manage/getDocFollow",
    method: "get",
    params: {
      ...params,
      currentPage,
      pageSize,
    },
  });
};

export const getWeekReport = (wxUserId) => {
  return request({
    url: "/manage/getWeekReport",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const getOnlineWorkOrder = (currentPage, pageSize, params) => {
  return request({
    url: "/manage/getOnlineWorkOrder",
    method: "get",
    params: {
      ...params,
      currentPage,
      pageSize,
    },
  });
};

export const saveOrUpdateOnlineWorkOrder = (item) => {
  return request({
    url: "/manage/saveOrUpdateOnlineWorkOrder",
    method: "post",
    data: item,
  });
};

export const deleteOnlineWorkOrder = (item) => {
  return request({
    url: "/manage/deleteOnlineWorkOrder",
    method: "post",
    data: item,
  });
};

export const getOnlineConsult = (currentPage, pageSize, params) => {
  return request({
    url: "/manage/getOnlineConsult",
    method: "get",
    params: {
      ...params,
      currentPage,
      pageSize,
    },
  });
};

export const getConsultDoc = (wxUserId) => {
  return request({
    url: "/manage/getConsultDoc",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const getConsultDetail = (wxUserId) => {
  return request({
    url: "/manage/getConsultDetail",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const getElec = (imei, day) => {
  return request({
    url: "/manage/getElec",
    method: "get",
    params: {
      imei,
      day,
    },
  });
};

export const getLabel = (wxUserId) => {
  return request({
    url: "/manage/getLabel",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const addLabel = (wxUserId, label) => {
  return request({
    url: "/manage/addLabel",
    method: "get",
    params: {
      wxUserId,
      label,
    },
  });
};

export const delLabel = (wxUserId, index) => {
  return request({
    url: "/manage/delLabel",
    method: "get",
    params: {
      wxUserId,
      index,
    },
  });
};

export const getDataDetail = (wxUserId) => {
  return request({
    url: "/manage/getDataDetail",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const getUserJkDetail = (wxUserId) => {
  return request({
    url: "/manage/getUserJkDetail",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const getWatchDetail = (wxUserId, imei) => {
  return request({
    url: "/manage/getWatchDetail",
    method: "get",
    params: {
      wxUserId,
      imei,
    },
  });
};

export const getChannel = () => {
  return request({
    url: "/manage/getChannel",
    method: "get",
  });
};

export const updChannel = (wxUserId, channel) => {
  return request({
    url: "/manage/updChannel",
    method: "get",
    params: {
      wxUserId,
      channel,
    },
  });
};

export const getWeightControl = (wxUserId) => {
  return request({
    url: "/manage/getWeightControl",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const getBodyDate = (wxUserId) => {
  return request({
    url: "/manage/getBodyDate",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const getClinicalExercise = (wxUserId) => {
  return request({
    url: "/manage/getClinicalExercise",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const getLossWeightUser = (currentPage, pageSize, params) => {
  return request({
    url: "/manage/getLossWeightUser",
    method: "get",
    params: {
      ...params,
      currentPage,
      pageSize,
    },
  });
};

export const getBpCalibrationRecordsLimit = (wxUserId, count, imei) => {
  return request({
    url: "/manage/getBpCalibrationRecordsLimit",
    method: "get",
    params: {
      wxUserId,
      count,
      imei,
    },
  });
};

export const bloodCalibration = (bp) => {
  return request({
    url: "/manage/bloodCalibration",
    method: "post",
    data: bp,
  });
};

export const saveClinicalFollow = (clinicalFollow) => {
  return request({
    url: "/manage/saveClinicalFollow",
    method: "post",
    data: clinicalFollow,
  });
};

export const getClinicalFollow = (wxUserId) => {
  return request({
    url: "/manage/getClinicalFollow",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const deleteClinicalFollow = (id) => {
  return request({
    url: "/manage/deleteClinicalFollow",
    method: "get",
    params: {
      id,
    },
  });
};

export const getDateCenter_lossWeight = (channel) => {
  return request({
    url: "/manage/getDateCenter_lossWeight",
    method: "get",
    params: {
      channel,
    },
  });
};

export const getDataStatistic = (params) => {
  return request({
    url: "/manage/getDataStatistic",
    method: "post",
    data: params,
  });
};

export const getOnlineManageDataCenter = (params) => {
  return request({
    url: "/manage/getOnlineManageDataCenter",
    method: "get",
    params: {
      ...params,
    },
  });
};

export const getWeightTrend = (wxUserId) => {
  return request({
    url: "/manage/getWeightTrend",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const getWeightTrendByMeterData = (params) => {
  return request({
    url: "/manage/getWeightTrendByMeterData",
    method: "post",
    data: params,
  });
};

export const getOnlineDepartment = (department, channel) => {
  return request({
    url: "/manage/getOnlineDepartment",
    method: "get",
    params: {
      department,
      channel,
    },
  });
};

export const savePcDoctorOrder = (orderRequest) => {
  return request({
    url: "/manage/savePcDoctorOrder",
    method: "post",
    data: orderRequest,
  });
};

export const getDoctorOrder = (wxUserId) => {
  return request({
    url: "/manage/getDoctorOrder",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const getDoctorOrderDetail = (wxUserId, orderId) => {
  return request({
    url: "/manage/getDoctorOrderDetail",
    method: "get",
    params: {
      wxUserId,
      orderId,
    },
  });
};

export const removeDoctorOrder = (wxUserId, orderId) => {
  return request({
    url: "/manage/removeDoctorOrder",
    method: "get",
    params: {
      wxUserId,
      orderId,
    },
  });
};

export const getPcRemindAndInform = (currentPage, pageSize, params) => {
  return request({
    url: "/manage/getPcRemindAndInform",
    method: "get",
    params: {
      ...params,
      currentPage,
      pageSize,
    },
  });
};

export const savePcRemindAndInform = (row) => {
  return request({
    url: "/manage/savePcRemindAndInform",
    method: "post",
    data: row,
  });
};

export const removePcRemindAndInform = (row) => {
  return request({
    url: "/manage/removePcRemindAndInform",
    method: "post",
    data: row,
  });
};

export const addUserToService = (row) => {
  return request({
    url: "/manage/addUserToService",
    method: "post",
    data: row,
  });
};

export const removeUserFromService = (row) => {
  return request({
    url: "/manage/removeUserFromService",
    method: "post",
    data: row,
  });
};

export const getSleepDataByDate = (wxUserId, date) => {
  return request({
    url: "/manage/getSleepDataByDate",
    method: "get",
    params: {
      wxUserId,
      date,
    },
  });
};

export const getServiceDepartment = (department, channel) => {
  return request({
    url: "/manage/getServiceDepartment",
    method: "get",
    params: {
      department,
      channel,
    },
  });
};

export const getSchemeNutritionNew = (wxUserId) => {
  return request({
    url: "/manage/getSchemeNutritionNew",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const getExerciseSchemeNew = (wxUserId) => {
  return request({
    url: "/manage/getExerciseSchemeNew",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const getExercisePrescription = (wxUserId) => {
  return request({
    url: "/manage/getExercisePrescription",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const getExercisePrescriptionReportList = (wxUserId) => {
  return request({
    url: "/manage/getExercisePrescriptionReportList",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const getExercisePrescriptionByReportId = (wxUserId, reportId) => {
  return request({
    url: "/manage/getExercisePrescriptionByReportId",
    method: "get",
    params: {
      wxUserId,
      reportId,
    },
  });
};

export const createExercisePrescription = (wxUserId) => {
  return request({
    url: "/manage/createExercisePrescription",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const deleteExercisePrescription = (reportId) => {
  return request({
    url: "/manage/deleteExercisePrescription",
    method: "get",
    params: {
      reportId,
    },
  });
};

export const updateChatDate = (wxUserId) => {
  return request({
    url: "/manage/updateChatDate",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const getHealthManager = (wxUserId, channel) => {
  return request({
    url: "/manage/getHealthManager",
    method: "get",
    params: {
      wxUserId,
      channel,
    },
  });
};

export const alterManager = (isMy, docId, wxUserId) => {
  return request({
    url: "/manage/alterManager",
    method: "get",
    params: {
      isMy,
      docId,
      wxUserId,
    },
  });
};

export const HealthStrategy = (wxUserId) => {
  return request({
    url: "/manage/HealthStrategy",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const review = (wxUserId) => {
  return request({
    url: "/manage/review",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const drugPlan = (wxUserId) => {
  return request({
    url: "/manage/drugPlan",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

// 获取亚健康 - 新
export const getSubHealthNew = (wxUserId) => {
  return request({
    url: "/manage/getSubHealthNew",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

// 获取慢性病 - 新
export const getChronicNew = (wxUserId) => {
  return request({
    url: "/manage/getChronicNew",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const getRiskNew = (wxUserId) => {
  return request({
    url: "/manage/getRiskNew",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const getIntelligentCustomerService = (currentPage, pageSize, params) => {
  return request({
    url: "/manage/getIntelligentCustomerService",
    method: "get",
    params: {
      ...params,
      currentPage,
      pageSize,
    },
  });
};

export const getNoticeNum = (currentPage, pageSize, params) => {
  return request({
    url: "/manage/getNoticeNum",
    method: "get",
    params: {
      ...params,
      currentPage,
      pageSize,
    },
  });
};

export const updateWarnResponseTime = (params) => {
  return request({
    url: "/manage/updateWarnResponseTime",
    method: "post",
    data: params,
  });
};

export const getIndexCount = () => {
  return request({
    url: "/manage/getIndexCount",
    method: "get",
  });
};

export const getSleepData = (params) => {
  return request({
    url: "/manage/getSleepData",
    method: "post",
    data: params,
  });
};

export const sendMsg = (params) => {
  return request({
    url: "/groupChat/sendMsg",
    method: "post",
    data: params,
  });
};

export const close = (userId) => {
  return request({
    url: "/groupChat/close",
    method: "get",
    params: {
      userId,
    },
  });
};

export const getIntelligentManage = (params) => {
  return request({
    url: "/manage/getIntelligentManage",
    method: "post",
    data: params,
  });
};

export const getWaitTask = (params) => {
  return request({
    url: "/manage/getWaitTask",
    method: "post",
    data: params,
  });
};

export const getAiWeekReportStateByUser = (wxUserId) => {
  return request({
    url: "/AiWeekReport/getAiWeekReportStateByUser",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const addAiWeekReportByUserReport = (wxUserId) => {
  return request({
    url: "/AiWeekReport/addAiWeekReportByUserReport",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const addAiWeekReportByUser = (wxUserId) => {
  return request({
    url: "/AiWeekReport/addAiWeekReportByUser",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const getDeviceToPush = (wxUserId) => {
  return request({
    url: "/manage/getDeviceToPush",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const pushMessage = (imei, content, title) => {
  return request({
    url: "/manage/pushMessage",
    method: "get",
    params: {
      imei,
      content,
      title,
    },
  });
};

export const createReportUser = (params) => {
  return request({
    url: "/manage/createReportUser",
    method: "post",
    data: params,
  });
};

export const getLongTermDoctorOrder = (wxUserId, date) => {
  return request({
    url: "/manage/getLongTermDoctorOrder",
    method: "get",
    params: {
      wxUserId,
      date,
    },
  });
};

export const bpReport = (wxUserId, year, week) => {
  return request({
    url: "/manage/bpReport",
    method: "get",
    params: {
      wxUserId,
      year,
      week,
    },
  });
};

export const getArchiveInfo = (wxUserId) => {
  return request({
    url: "/manage/getArchiveInfo",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const micProfessional = (wxUserId) => {
  return request({
    url: "/manage/micProfessional",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const getQaResult = (wxUserId) => {
  return request({
    url: "/manage/getQaResult",
    method: "get",
    params: {
      wxUserId,
    },
  });
};

export const getFitnessEvaluate = (wxUserId) => {
  return request({
    url: "/manage/getFitnessEvaluate",
    method: "get",
    params: {
      wxUserId,
    },
  });
};
